import { createSlice } from "@reduxjs/toolkit";

const initialGradeAndSectionReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const gradeAndSectionReportSlice = createSlice({
  name: "gradeAndSectionReport",
  initialState: initialGradeAndSectionReportState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGradeAndSectionReport
    gradeAndSectionReportFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanGradeAndSectionReportState
    gradeAndSectionReportStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
    }
  }
});